import { HTTPError } from 'ky';
import _omit from 'lodash/omit';
import type { ErrorPayload } from '../../consts/error';

export class UAFetchError<T = Record<string, unknown>> extends HTTPError<T> {
  payload: ErrorPayload<T> | undefined;
  status: number;
  statusText: string;
  url: string;
  reqHeaders: Record<string, unknown>;

  constructor({
    request,
    response,
    options,
    message,
    payload,
    status,
    statusText,
    url,
  }: {
    request: HTTPError['request'];
    response: HTTPError['response'];
    options: HTTPError['options'];
    message: string;
    payload?: ErrorPayload<T>;
    url: string;
    status: number;
    statusText: string;
  }) {
    super(response, request, options);
    this.status = status;
    this.statusText = statusText;
    this.url = url;
    this.message = message;
    this.payload = payload;
    this.reqHeaders = Object.fromEntries(request.headers);
    // to reduce noise
    this.options = _omit(options, [
      'hooks',
      'retry',
      'headers',
      'prefixUrl',
      'signal',
      'searchParams',
    ]) as typeof options;
    this.name = 'UAFetchError';
  }
}
